const schema = {
    contract: {
        id: 'contract',
        label: '',
        value: '',
        required: true,
        type: 'select',
    },
    name: {
        id: 'name',
        placeholder: 'Nome',
        value: '',
        required: true,
        type: 'text',
        icon: { name: 'search', type: 'round' },
    },
    email: {
        id: 'email',
        placeholder: 'E-mail',
        value: '',
        required: true,
        type: 'text',
        icon: { name: 'search', type: 'round' },
    },
    role: {
        id: 'role',
        placeholder: 'Cargo',
        value: '',
        required: true,
        type: 'text',
        icon: { name: 'search', type: 'round' },
    },
};

export default schema;
